<div style="width: auto" class="share-icon-content">
  <a (click)="openModal(sideNav)" class="share-content-icon">
    <img
      src="./assets/images/share_24.svg"
      alt="share"
      class="share-image-icon"
      [ngStyle]="customStyle"
    />
  </a>
  <div class="noprint">
    <ng-template #sideNav>
      <div class="modal-body">
        <!-- <div class="share_icons">
          <div
            *ngFor="let btn of shareBtns"
            class="share_icon"
          >
            <share-button
              [theme]="'circles-dark'"
              [button]="btn.name"
              [text]="btn.text"
              [showText]="true"
            ></share-button>
          </div>
        </div> -->
        <share-buttons
          [theme]="'circles-dark'"
          [include]="[
            'facebook',
            'twitter',
            'linkedin',
            'telegram',
            'messenger',
            'whatsapp',
            'email',
            'print',
            'copy'
          ]"
          [show]="10"
          [showText]="true"
          [url]="currentUrl"
          [autoSetMeta]="true"
        ></share-buttons>
      </div>
    </ng-template>
  </div>
</div>
